(function () {
  'use strict';

  angular.module('eclipseApp.linkAccount').config(['$stateProvider', 'dtmServiceConstants', function ($stateProvider, dtmServiceConstants) {
    $stateProvider
      .state('linkAccounts', {
        url: '/link-account',
        parent: 'app',
        title: 'linkAccount',
        data: {
          janrainAuthRequired: true,
          showSubHeading: false
        },
        dtm: {
          transaction: dtmServiceConstants.dtmRules.dtmLinkAccount.ruleName,
          type: dtmServiceConstants.type.active,
          action: dtmServiceConstants.actions.start,
          project: dtmServiceConstants.project.myAccount
        },
        views: {
          content: {
            templateUrl: 'modules/link-account/link-account.view.html',
            controller: 'linkAccountCtrl',
            controllerAs: 'ctrl'
          }
        }
      });
  }]);
})();
